import React, { useContext } from 'react'

export const GlobalWallet = React.createContext()

export default function useWallet() {
  const walletContext = useContext(GlobalWallet)
  return walletContext
}
